export const PARTNER_PACKAGES = [
  {
    id: 'starter',
    name: 'Starter',
    price: 29.99,
    priceDisplay: '29,99 € inkl. MwSt.',
    commission: 30,
    commissionDisplay: '30 %',
    description: 'Perfekt für den Einstieg',
    features: [
      'Zugang zum Partner-Portal',
      '30 % Provision vom Grundhonorar',
      'Unbegrenzte Fallvermittlung'
    ],
    popular: false
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 49.99,
    priceDisplay: '49,99 € inkl. MwSt.',
    commission: 40,
    commissionDisplay: '40 %',
    description: 'Beste Balance aus Preis und Provision',
    features: [
      'Zugang zum Partner-Portal',
      '40 % Provision vom Grundhonorar',
      'Unbegrenzte Fallvermittlung',
      'Prioritäts-Support'
    ],
    popular: true,
    badge: 'Beliebtestes Paket'
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 79.99,
    priceDisplay: '79,99 € inkl. MwSt.',
    commission: 50,
    commissionDisplay: '50 %',
    description: 'Für Partner mit regelmäßigem Volumen',
    features: [
      'Zugang zum Partner-Portal',
      '50 % Provision vom Grundhonorar',
      'Unbegrenzte Fallvermittlung',
      'Prioritäts-Support',
      'Früher Zugang zu neuen Features'
    ],
    popular: false
  }
];

export const getPackageById = (id) => {
  return PARTNER_PACKAGES.find(pkg => pkg.id === id) || PARTNER_PACKAGES[1]; // Default: Pro
};

export const getCommissionRate = (tier) => {
  const pkg = getPackageById(tier);
  return pkg ? pkg.commission / 100 : 0.40; // Default 40%
};
